export default __webpack_public_path__ + "static/media/09-Bulgari-Logo.bbdb7537.png";